import module from 'contabilidad/catalogosexternos/module'
import template from './template.html'

export class SucursalesComponent {
}

module.component('contabilidadCatalogosexternosSucursales', {
  controller: SucursalesComponent,
  template: template,
})




// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/sucursales/component.js